'use strict';

exports.__esModule = true;

var _user = require('./models/user');

var _user2 = _interopRequireDefault(_user);

var _job = require('./models/job');

var _job2 = _interopRequireDefault(_job);

var _card = require('./models/card');

var _card2 = _interopRequireDefault(_card);

var _order = require('./models/order');

var _order2 = _interopRequireDefault(_order);

var _item = require('./models/item');

var _item2 = _interopRequireDefault(_item);

var _waypoint = require('./models/waypoint');

var _waypoint2 = _interopRequireDefault(_waypoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModelProvider = {
  User: _user2.default,
  Job: _job2.default,
  Card: _card2.default,
  Order: _order2.default,
  Item: _item2.default,
  Waypoint: _waypoint2.default
};

exports.default = ModelProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/model-provider.js
// module id = 61
// module chunks = 0